module.exports = __webpack_public_path__ + "static/img/327_TO8_2514_og.8079902.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/327_TO8_2514_og.jpg
// module id = fqa1
// module chunks = 0